import GentleAppState from '../common/appstate';
import GentleServiceAccount from '../service/account';
import GentleUtil from '../common/util';
import GentleLang from '../common/lang';
import GentleApi from '../common/api';
import GentleServiceCustomHandler from '../service/customServiceHandler';
import GentleServiceBonus from '../service/bonus';
import GentleComponentBubble from '../component/bubble';
import GentleLangDir from '../lang';
import GentleServiceHome from '../service/home';
import SvcAccount from '../service/svc_account';

import Const from '../common/const';
// import Gateway from '../js/spectra_enomix/gateway/gateway';
// window.Gateway = Gateway;
// let abc = GentleAppState
// console.log("123123123121",GentleAppState. isPrd)
export function printBubble(html){
    var bubble = Object.create( GentleComponentBubble );               
    bubble.createComponent({                    
        html,            
    });            
    bubble.insert();
}

export function addHistory(obj){
    if(!window.chatbotHistory) window.chatbotHistory = [];
    window.chatbotHistory.push(obj);
}

export function hereLang(){
    return GentleAppState.lang;
}
export function devOrPrd(){
    return serverData.ServerProfile;
}
export function getGentleLang() {
    return GentleLang;
}
// 언어팩 외부 접근 
export function translate(type, opts){
    return GentleLang.translate(type, opts);
}

// 커스텀 서비스 핸들러 외부 접근 
export function customServiceHandler(json) { 
    console.log(json);
    GentleServiceCustomHandler.handler(json);
}

// 사용자 발화가 입력됬다.
export function onInput(text) { 
    GentleServiceCustomHandler.onInput(text);
}

// 스크롤 인터렉션 외부 접근
export function scrollInteraction() { 
    GentleUtil.scrollInteraction();
}

window.onload = function(){
    console.log = () => {};
    
    if(!window.debugOption){
        window.debugOption = {
            account: 1, // 0 : papa, 1 : tommy, 2: user            
        }
    }
    
    // 테스트용 서비스 목록 (발화 대신 로딩 직후 서비스 호출)
    const prop = {        
        // service: 'GentleServiceCallCenter.info',
        // service: 'GentleServiceConsulting.insertReview',
        // service: 'GentleServiceCallCenter.chat',
        // service: 'GentleServiceHome.main',
        // service: 'GentleServiceTip.whatdo',
        // service: 'GentleServiceTip.invite',
        // service: 'GentleServiceTip.plan',
        // service: 'GentleServiceTip.profile',
        // service: 'GentleServiceAccount.login',
        // service: 'GentleServiceAccount.logoutEntry',
        // service: 'GentleServiceAccount.logout',
        // service: 'GentleServiceAccount.loginCheck',
        // service: 'GentleServiceAccount.lowerList', // 관심회원
        // service: 'GentleServiceProfile.main',
        // service: 'GentleServiceInviteMember.main',
        // service: 'GentleServiceSales.main', // 매출조회
        // service: 'GentleServiceSales.popupMySalse', // 나의 매출 내역
        // service: 'GentleServiceSales.recommend', // 소실적 맞춤상품 추천
        // service: 'GentleServiceBonus.main',
        // service: 'GentleServiceBonus.huwonBonus',   // 후원수당 조회
        // service: 'GentleServiceBonus.huwonBonusOccurrence',   // 후원수당 발생내역
        // service: 'GentleServiceBonus.positionPay',   // 직급내역 보기
        // service: 'GentleServiceProduct.bestList',
        // service: 'GentleServiceSearch.main',
        // service: 'GentleServiceProduct.popupOption',
        // service: 'GentleServiceCart.main',
        // service: 'GentleServiceCart.done',
        // service: 'GentleServiceOrder.main',  // 주문내역
        // service: 'GentleServiceJoin.main',
        // service: 'GentleServiceNotice.main',
        // service: 'GentleServiceSchedule.main',
        // service: 'GentleServiceSchedule.seminar', // 세미나 일정 조회
        // service: 'GentleServiceCallCenter.main',
        // service: 'GentleServiceCallCenter.info',
        // service: 'GentleServiceApprove.main',
        // service: 'GentleServiceProduct.new',
        // service: 'GentleServiceMarketingPlan.main',
    }

    if(prop.service){
        alert('test mode');
    }

    const callback = function(){
        let aIframe = document.createElement("iframe");
        aIframe.setAttribute("id","iframeSSOProcess");
        aIframe.setAttribute("frameborder","0");
        aIframe.style.width = "500px";
        aIframe.style.height = "0px";
        // aIframe.src = `${'http://localhost:3000'}/test.html?${'http://localhost:8080/'}` //로컬
        // aIframe.src = `${'https://dev-api.atomyn.kr'}/ssoProcess.html?${'https://chat-dev.atomy.kr/'}` //개발
        aIframe.src = `${'https://shop-api-ga.atomy.com'}/ssoProcess.html?${'https://chat.atomy.kr/'}` //운영
        document.getElementsByClassName("chatbot-start")[0].appendChild(aIframe);

        
        console.log('GentleAppState>', GentleAppState);
        GentleAppState.getGlobalToken();

        if(GentleAppState.AtomyUserToken !== '' && GentleAppState.AtomyRefreshToken !==''){
            console.log('setGlobalToken')
            GentleAppState.setGlobalToken();
        }
        GentleServiceHome.hello();
        
        window.addEventListener('message', (event) => {
            const { data, origin } = event
            // 메시지 처리
            if(origin === `https://shop-api-ga.atomy.com`){
                console.log("메시지를 받았음.", origin)
                if(data.key === `responseSSOToken`){
                    if(data.value.token === null || data.value.token === undefined){
                        console.log("넘어오는 토큰이 없음")
                    }else{
                        console.log('[parent] message is received:\n', '{token : ',data.value.token, '}\n',  '{origin : ',origin, '}')
                        //sso-check
                        GentleServiceAccount.ssoCheck(data.value.token);
                    }
                }
            }
          })

        // const lang = GentleAppState.lang.toUpperCase();
        
        $("#chatText").attr("placeholder", GentleLang.translate(GentleLang.type.ChatPlaceholder));
        
        // GentleUtil.createUpdateToastMessage(GentleLang.tomy.kr.UpdateNotice);

        const type = Math.floor(Math.random() * 3);
        
        // bind
        const { persona } = GentleAppState;
        const isBusiMember = persona === GentleLang.persona.TOMMY;

        // 로딩 직후 연결할 서비스가 있는가?
        {
            const service = localStorage.getItem(Const.Storage.service);
            localStorage.setItem(Const.Storage.service, '');


            if(GentleAppState.isLogin){
                if(service){
                    console.log('service로 이동', service);
                    prop.service = service;
                }
            }
        }
        
        if(!prop.service)
        {
            const visitCount = (localStorage.visitCount ? localStorage.visitCount : 0) % 4;
            localStorage.visitCount = visitCount + 1;
            
            if(GentleAppState.isLogin){
                if(isBusiMember) // 사업자회원
                {
                    // GentleUtil.createUpdateToastMessage(GentleLang.tomy.kr.UpdateNotice);


                    const today = new Date();
                    const h = today.getHours();

                    const y = today.getFullYear();
                    const m = today.getMonth() + 1;
                    const d = Number(today.getDate());
                    let lastDay;  // 이번달 마지막 날
                    {
                        let temp = new Date(y, m, -3);
                        lastDay = temp.getDate();
                    }

                    let isInTime = true; // 00~09:00 or 12~21:59
                    {
                        // 00~08:59 or
                        if(
                            (h > 8 && h < 12)
                            || (h > 21 && h < 23)
                        ){
                            isInTime = false; // 표에서 하단
                        }
                    }

                    let isInDays = false;
                    {                        
                        if(
                            (d > 11 && d < 20) // 11< today < <20
                            || d < 4
                            || d > lastDay
                        ){
                            isInDays = true;
                        }
                    }

                    // test code
                    // isInTime = false;
                    // isInDays = false;
 
                    // todo : 
                    if(isInTime)
                    {
                        switch (visitCount) {
                            case 0:
                                // prop.service = 'GentleServiceSales.main'; // 현황조회
                                break;
                            case 1:
                                prop.service = 'GentleServiceSchedule.main'; // 오늘 일정
                                break;
                            case 2:
                                prop.service = 'GentleServiceOrder.main'; // 최근 주문내역
                                break;
                            case 3:
                                prop.service = 'GentleServiceTip.whatdo'; // 기능팁
                                break;                        
                            default:
                                break;
                        }
                    }
                    else
                    {
                        if(isInDays){
                            console.log("main 257")
                            // 직급내역 +
                            // 후원수당(3일간 하위매출)
                            {
                                const lang = GentleAppState.lang.toUpperCase();
                                const name = GentleAppState.custName;
                                const html = lang === GentleLang.lang.KR ? 
                                    `안녕하세요. ${name}님, 최근 직급내역과 후원수당을 보여드리겠습니다. 정산 마감 시점에 매출 변동이 생기면 내역도 변경될 수 있어요.` 
                                    : `Hello, ${name}. We will show you the latest Mastership Achievement and general commission. If there is a change in sales at the end of the settlement period, the details may also change.`
                                var bubble = Object.create( GentleComponentBubble );   
                                bubble.createComponent({
                                        html,
                                });
                                bubble.insert();
                            }

                            const completed = function(){
                                customServiceHandler({ 
                                    service: 'GentleServiceBonus.huwonBonus',
                                    simple: true,
                                });
                            }

                            // GentleServiceBonus.positionPay({completed, simple: true});
                        }
                        else{
                            console.log("후원수당 main 282")
                            // GentleServiceBonus.huwonBonus({});    // 후원수당
                        }
                    }
    
                }
                else // 사업자 회원이 아님
                {//GentleServiceConsulting.TalkAvailable();
                    if(visitCount === 0){ // 최초 방문의 경우
                        prop.service = 'GentleServiceProfile.main';
                    }
                    else{
                        switch (type) {
                            case 0: // 주문내역조회
                                prop.service = 'GentleServiceHome.main';
                                break;
                            case 1: // 인기상품
                                //2022-11-17 인기상품 api는 사용하지 않게 되어서 당장에는 둘다 신상품으로 보여줌
                                // prop.service = 'GentleServiceProduct.bestList';
                                prop.service = 'GentleServiceHome.main';
                                // prop.service = 'GentleServiceProduct.new';
                                break;
                            case 2: // 신상품
                                prop.service = 'GentleServiceHome.main';
                                // prop.service = 'GentleServiceProduct.new';
                                break;
                        
                            default:
                                prop.service = 'GentleServiceHome.main';
                                break;
                        }
                        prop.isLoaded = true; // 첫 로딩 화면인가?
                    }
                }
            }else{  // not login
                prop.service = 'GentleServiceConsulting.TalkAvailable'
                switch (type) {
                    case 0: // 로그인
                        prop.service = 'GentleServiceHome.main';
                        break;
                    case 1: // 인기상품
                        //2022-11-17 인기상품 api는 사용하지 않게 되어서 당장에는 둘다 신상품으로 보여줌
                        // prop.service = 'GentleServiceProduct.bestList';
                        // prop.service = 'GentleServiceProduct.new';
                        prop.service = 'GentleServiceHome.main';
                        break;
                    case 2: // 신상품
                        // prop.service = 'GentleServiceProduct.new';
                        prop.service = 'GentleServiceHome.main';
                        break;
                
                    default:
                        prop.service = 'GentleServiceSearch.main';

                        break;
                }
            }

            // {
            //     const bubble = GentleUtil.sorry();
            //     bubble.insert();
            // }            
        }

        if(prop.service)
            customServiceHandler(prop);

        
        // 앱 로딩 및 사용자 도움말 인트로 초기화 
        {
            customServiceHandler(
                {
                    service: 'GentleServiceIntro.introInit',
                    intro: {
                        // skipAppLoading:true, 
                        // ignoreCookie:true, 
                        // startScene:'scene-papa-16',
                    }
                }, 
            );
        }
        
        // 퀵메뉴 초기화 
        GentleUtil.quickMenuInit({
            persona:GentleAppState.persona
        });


        // 젠파용 서비스 리스트 확인
        if(GentleAppState.testMode === true){
            GentleUtil.serviceListInit({
                persona:GentleAppState.persona
            }); 
        }
    }

    const SVC = Object.create(SvcAccount);
    SVC.account()    
    
    // 현재 봇 고유번호로 웹소켓 연결 
    console.log('window.location', window.location.pathname);
    console.log(window.location.href);
    const params = window.location.href.split('?');
    if(params.length > 1){
        const param = params[1]
        const token = String(param).substring(2, param.length);
        console.log('token>', token);
        if(token.length){
            const pros = {
                service: 'GentleServiceAccount.sso',
                token //: 'tuULkg8Cbyxh/MBtHkyWlnvPM1MrjveruEG15kvMGFFHsX0j1WARr8/w9z9i0pWOL3N+mdKXSV0D8nxphmgo0+o8n6S8kUdLz1Sbq7mPBlNM+Trw2PkqrdAJxzMZklQQsL6HLX1ABIUlqhUbCl1Gzsk+QyxO4kT5S737Vgv2SWA='
            }
            customServiceHandler(pros)
            return;
        }
    }

    const botCd = window.location.pathname.split('/').pop();
    connectServer(botCd);

    // 연결 활성화 된 이후 앱상태 초기화 
    var appInitTimer = setInterval(function(){
        if(window.chatSession.connected === true){
            
            GentleAppState.init(callback);
            clearInterval(appInitTimer);

                
                

        }else{
            console.log('연결활성화 되지 않음.')
        }
    },500); // 50 -> 500 무한루프 현상으로 인터벌간격을 수정
    
    

    let finiteValidation = function(){
        let keyFamily = Object.keys(GentleLangDir);
        for(let i=0; i < keyFamily.length; i++){
        
            let typeValidation=function(keyFamily){      
                const str = keyFamily[i];   
                if(str ==='callCenter' || str ==='index' || str ==='url'){
                    return console.log(`${str}에는 누락값이 없습니다.`)
                }
                let typeResult = GentleLangDir[`${str}`].type; //객체
                let typeResultPK = GentleLangDir[`${str}`].papa.kr; //객체
                let typeResultPE = GentleLangDir[`${str}`].papa.eng; //객체
                let typeResultTK = GentleLangDir[`${str}`].tomy.kr; //객체
                let typeResultEN = GentleLangDir[`${str}`].tomy.eng; //객체
                // 객체 배열화
                let typeResultArr = Object.keys(typeResult);
                let papaResultKR = Object.keys(typeResultPK);
                let papaResultEN = Object.keys(typeResultPE);
                let tomyResultKR = Object.keys(typeResultTK);
                let tomyResultEN = Object.keys(typeResultEN);
                // 배열간의 비교
                let papaKR = (typeResultArr.filter(key => !papaResultKR.includes(key)));
                let papaEN = (typeResultArr.filter(key => !papaResultEN.includes(key)));
                let tomyKR = (typeResultArr.filter(key => !tomyResultKR.includes(key)));
                let tomyEN = (typeResultArr.filter(key => !tomyResultEN.includes(key)));

                if(papaKR.length ===0 && papaEN.length ===0 && tomyKR.length ===0 && tomyEN.length ===0){
                    return console.log(`${keyFamily[i]}에는 누락값이 없습니다.`)
                }else{
                    return console.log(`${keyFamily[i]}의 누락된 키값>>>`,papaKR,papaEN,tomyKR,tomyEN);
                }
            }
            typeValidation(keyFamily);  
        
        
        }
    }
}